import PriceBookItemCreateContainer from "@legacy/pricebook/PriceBookItemCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { PRICEBOOK_ITEMS_ROUTES } from "@routes/pricebook-items"

import { DECODED_PRICEBOOK_ITEM_URL_PARAM_TYPE_VALUES_MAP } from "@constants/decodedPricebookItemURLParamTypeValues"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { LIST_SEARCH_PARAM_TYPE } from "@constants/searchParams"

function PricebookCreateContent() {
    const [listRoute] = useSlugExtractor([PRICEBOOK_ITEMS_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const pricebookTypeFromURL = new URLSearchParams(window.location.search).get(LIST_SEARCH_PARAM_TYPE)
    const backDestinationWithType = pricebookTypeFromURL
        ? `${listRoute}?${LIST_SEARCH_PARAM_TYPE}=${DECODED_PRICEBOOK_ITEM_URL_PARAM_TYPE_VALUES_MAP[pricebookTypeFromURL]}`
        : listRoute

    const backDestination = hasPermission("pricebook_list_permission", PERMISSION_LEVEL.FULL)
        ? backDestinationWithType
        : undefined

    return (
        <>
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label="New Pricebook Item" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <PriceBookItemCreateContainer formMode="ADD_PRICEBOOKITEM" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </>
    )
}

export default function PricebookCreate() {
    return (
        <AppFrame.Root navigationType="inner">
            <PricebookCreateContent />
        </AppFrame.Root>
    )
}
